import { Button } from 'common/button';
import { PaymentMethod } from 'common/payment-method';
import { AppContext } from 'context/app-context';
import {
  StoreAction,
  StoreStateType,
} from 'context/store-context/store-reducer';
import { classnames } from 'helpers/utils';
import React, { useContext } from 'react';
import { RouteName, goToPage } from 'routes';
import { OrderList } from './OrderList';
import styles from './checkout.module.scss';

type PaymentSummaryProps = {
  state: StoreStateType;
  dispatch: React.Dispatch<StoreAction>;
};
export const PaymentSummary: React.FC<PaymentSummaryProps> = ({
  state,
  dispatch,
}) => {
  const { state: generalState } = useContext(AppContext);
  const showPaymentMethod = () => (
    <div className={classnames(styles.paymentBox)}>
      <div
        className={classnames(
          styles.title,
          'text__body__regular__overline__gray800',
        )}
      >
        PAYMENT METHOD
      </div>
      <PaymentMethod paymentMethod={generalState.data.user.paymentMethods[0]} />
    </div>
  );
  return (
    <div className={styles.orderDetailsContent}>
      <div className={styles.leftSection}>
        <div className={classnames(styles.paymentSummaryContent)}>
          <div className={classnames('text__body__regular__overline__gray800')}>
            ORDER CONFIRMATION
          </div>
          <div className={classnames(styles.paymentSummaryInformation)}>
            <div className={classnames('text__body__regular__medium__gray700')}>
              Your order number is{' '}
              <span className="text__body__semi__bold__medium__gray700">
                #{state.orderId}
              </span>
              . We’ve sent you an email to{' '}
              <span className="text__body__semi__bold__medium__gray700">
                {state.shippingDetails.email}
              </span>{' '}
              with your order information.
            </div>
            <div className={classnames('text__body__regular__medium__gray700')}>
              If your order requires shipping we will notify you once it has
              been shipped and provide a tracking number. Digital products, such
              as extra storage and video call time, have already been added to
              their respective vaults.
            </div>
            <div className={classnames('text__body__regular__medium__gray700')}>
              Thank you for shopping with us!
            </div>
            <Button
              onClick={() => {
                dispatch({ type: 'GO_INITIAL_STATE' });
                goToPage(RouteName.Store);
              }}
              className={classnames(styles.fullWidth)}
            >
              Back to store
            </Button>
          </div>
        </div>
      </div>
      <div className={styles.rightSection}>
        <div className={styles.allItems}>
          <OrderList state={state} />
          {showPaymentMethod()}
        </div>
      </div>
    </div>
  );
};
